module.exports = __webpack_public_path__ + "resources/icon_28_down_active.25bc9f0e12b86620.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_28_down_active.png
// module id = 350
// module chunks = 0 1 2 3 4